import { render, staticRenderFns } from "./ProductSubscriptionButton.vue?vue&type=template&id=f5644282&"
import script from "./ProductSubscriptionButton.vue?vue&type=script&lang=js&"
export * from "./ProductSubscriptionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports